export default __webpack_public_path__ + "static/media/NotoSans-Light.ec7f2349.otf";